<ng-container
  *ngIf="{
    banners: currentBanner$ | async,
    config: carouselConfig$ | async,
  } as content"
>
  <ul class="grid-brands">
    <li *ngFor="let brand of content.banners">
      <cx-banner [item]="brand"></cx-banner>
    </li>
  </ul>
</ng-container>
